import React, { Component } from 'react'
import {
  LocaleActions,
  LocaleState
} from '@merchant-portal/merchant-portal-base'
import { getCountryFlag } from '../../../util/countries'
import styles from './styles.module.scss'
import { Countries } from '../../../models/countries'
import { Languages } from '../../../models/languages'

export class LanguageSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSelector: false,
    }
  }

  getCountryCode(lang) {
    switch (lang) {
      case Languages.FINNISH:
        return Countries.FI
      case Languages.DANISH:
        return Countries.DK
      case Languages.NORWEGIAN:
        return Countries.NO
      default:
        return Countries.SE
    }
  }

  getLanguageLabel(lang) {
    switch (lang) {
      case Languages.FINNISH:
        return 'Suomi'
      case Languages.DANISH:
        return 'Dansk'
      case Languages.NORWEGIAN:
        return 'Norsk'
      default:
        return 'Svenska'
    }
  }

  setLanguage(language, localeActions) {
    localeActions.setLanguage(language)
    this.setState({ showSelector: false })
  }

  availableLanguages = currentLanguage => Object.values(Languages).filter(n => n !== currentLanguage)

  render() {
    return (
      <LocaleState.Consumer>
        {locale =>
        <LocaleActions.Consumer>
        {localeActions =>
          <div className={styles.topRight}>
            <div>
              <img
                src={getCountryFlag(
                  this.getCountryCode(locale.language),
                )}
                className={styles.selectorFlag}
                onClick={() =>
                  this.setState({showSelector: !this.state.showSelector})
                }
              />
            </div>
            <div
              className={
                this.state.showSelector ? styles.selector : styles.disabled
              }
            >
              {this.availableLanguages(locale.language).map(lang => {
                return (
                  <div
                    key={lang}
                    className={styles.languageRow}
                    onClick={() => this.setLanguage(lang, localeActions)}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        key={lang}
                        src={getCountryFlag(this.getCountryCode(lang))}
                        className={styles.selectorFlag}
                      />
                    </div>
                    <label className={styles.languageLabel}>
                      {this.getLanguageLabel(lang)}
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
        }
        </LocaleActions.Consumer>
        }
      </LocaleState.Consumer>
    )
  }
}
